import React, { useState, useContext, useEffect } from "react";
import {
  Formik,
  Form as FormikForm,
  Field,
  ErrorMessage,
  useFormikContext,
} from "formik";
import { Form, Row, Col } from "react-bootstrap";
import Button from "@mui/material/Button";
import { TextField, Select, InputLabel } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import * as Yup from "yup";
import { TaskContext } from "../components/TaskContext";
import { UserDataContext } from "../components/UserDataContext";
import { apiRequest } from "../components/Config";

const initialValues = {
  person: "",
  taskDescription: "",
  sumNetto: "",
  vat: 23,
};

const TaskSettlementsForm = () => {
  const { values, setFieldValue, handleSubmit, isSubmitting } =
    useFormikContext();
  const [total, setTotal] = useState(0);
  const { userData } = useContext(UserDataContext);

  useEffect(() => {
    const sumNetto = parseFloat(values.sumNetto) || 0;
    const vat = parseFloat(values.vat) || 0;
    const totalValue = sumNetto + (sumNetto * vat) / 100;
    setTotal(totalValue.toFixed(2));
  }, [values.sumNetto, values.vat]);

  return (
    <FormikForm onSubmit={handleSubmit}>
      <Row style={{ marginBottom: "20px" }}>
        <Col md="2">
          <Form.Group controlId="formPerson">
            <InputLabel>Osoba </InputLabel>
            <Field as={TextField} name="person" fullWidth />
            <ErrorMessage
              name="person"
              component="div"
              className="text-danger"
            />
          </Form.Group>
        </Col>
        <Col md="4">
          <Form.Group controlId="formDescription">
            <InputLabel>Opis</InputLabel>
            <Field as={TextField} name="taskDescription" fullWidth />
            <ErrorMessage
              name="taskDescription"
              component="div"
              className="text-danger"
            />
          </Form.Group>
        </Col>
        <Col md="2">
          <Form.Group controlId="formSumNetto">
            <InputLabel>Netto - Wyk.</InputLabel>
            <Field
              as={TextField}
              name="sumNetto"
              type="number"
              onChange={(e) =>
                setFieldValue("sumNetto", parseFloat(e.target.value) || "")
              }
              fullWidth
            />
            <ErrorMessage
              name="sumNetto"
              component="div"
              className="text-danger"
            />
          </Form.Group>
        </Col>
        <Col md="2">
          <Form.Group controlId="formVat">
            <InputLabel>VAT</InputLabel>
            <Field as={Select} name="vat" fullWidth>
              <MenuItem value={23}>23%</MenuItem>
              <MenuItem value={8}>8%</MenuItem>
            </Field>
            <ErrorMessage name="vat" component="div" className="text-danger" />
          </Form.Group>
        </Col>
      </Row>
      <Row style={{ marginBottom: "20px" }}>
        <Col>
          <Form.Group controlId="formBank">
            <InputLabel>Bank</InputLabel>
            <Field as={TextField} name="taskBank" fullWidth />
            <ErrorMessage
              name="taskBank"
              component="div"
              className="text-danger"
            />
          </Form.Group>
        </Col>
      </Row>
      <Button type="submit" variant="outlined" disabled={isSubmitting}>
        Zapisz
      </Button>
      <hr />
      <p className="p3">Razem Brutto: {total}</p>
    </FormikForm>
  );
};

const TaskSettlementsAdd = ({ addedData }) => {
  const { taskId } = useContext(TaskContext);
  const { userData } = useContext(UserDataContext);
  const [available, setAvailable] = useState(0);

  const fetchAvailable = async () => {
    try {
      const response = await apiRequest(`availableNetto/${taskId}`, "GET");
      //console.log("availableNetto: ", response);
      setAvailable(response[0].totalSum);
    } catch (error) {
      console.error("Błąd w pobieraniu danych:", error);
    }
  };

  useEffect(() => {
    if (userData) {
      fetchAvailable();
    }
  }, [userData]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    values["taskId"] = taskId;
    //console.log("Form data submitted:", values);
    try {
      const response = await apiRequest("tasksettlement", "POST", values);
      addedData();
      await fetchAvailable();
      setSubmitting(false);
      resetForm();
    } catch (error) {
      console.error("Błąd podczas wysyłania formularza:", error);
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        person: Yup.string().required("Pole wymagane"),
        taskDescription: Yup.string()
          .max(100, "Opis zadania nie może przekraczać 100 znaków")
          .required("Pole wymagane"),
        sumNetto: Yup.number()
          .typeError("Wartość musi być liczbą")
          .required("Pole wymagane")
          .positive("Wartość musi być dodatnia")
          .max(available, "Wartość nie może przekraczać " + available),
        vat: Yup.number().required("Pole wymagane"),
      })}
      onSubmit={handleSubmit}
    >
      <TaskSettlementsForm />
    </Formik>
  );
};

export default TaskSettlementsAdd;
